import { render, staticRenderFns } from "./Step1Identify.vue?vue&type=template&id=3129e3fc&scoped=true&"
import script from "./Step1Identify.vue?vue&type=script&lang=js&"
export * from "./Step1Identify.vue?vue&type=script&lang=js&"
import style0 from "./Step1Identify.vue?vue&type=style&index=0&id=3129e3fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3129e3fc",
  null
  
)

export default component.exports